module.exports = __webpack_public_path__ + "1a21625871ae1666809d87008490f986.png";